// Aceternity UI Shimmer Loader - Professional skeleton loading
const ShimmerLoader = ({ count = 4, className = '' }) => {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-gray-200 to-gray-300 dark:from-gray-800 dark:to-gray-700 aspect-square"
        >
          {/* Shimmer animation */}
          <div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 dark:via-white/10 to-transparent"
            style={{
              animation: 'shimmer 2s infinite',
              backgroundSize: '200% 100%',
            }}
          />

          {/* Subtle pulse effect */}
          <div className="absolute inset-0 animate-pulse bg-gradient-to-br from-blue-400/10 to-purple-400/10" />

          <style>{`
            @keyframes shimmer {
              0% {
                backgroundPosition: -200% 0;
              }
              100% {
                backgroundPosition: 200% 0;
              }
            }
          `}</style>
        </div>
      ))}
    </div>
  );
};

export default ShimmerLoader;
